import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7284a3fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "メールアドレス", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item_value_text" }
const _hoisted_8 = { class: "profile_button_register" }
const _hoisted_9 = { class: "profile_button_modify" }

import { ref, computed } from 'vue';
import { putMailAddress } from '@/api/careersheetEndpoint';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';

type GlobalError = {
  code: string;
  args: string[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MailConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const emailAddress = computed(() => store.getters['userRegistration/mailAddress']);

const isLoading = ref(false);
const submitDisable = ref(false);
const apiErrorMessages = ref<string[]>([]);
const save = async () => {
  isLoading.value = true;
  try {
    await putMailAddress({ emailAddress: emailAddress.value });
    store.dispatch('toasts/appendTimeToast', { label: 'メールアドレスを更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e20', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n20' });
    }
  } catch (error) {
    console.error(error);
    store.dispatch('toasts/appendTimeToast', { label: 'メールアドレスの更新に失敗しました', duration: null });
    submitDisable.value = true;
    // apiから返却されるエラーメッセージを表示する
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      error.response.data.errorDetail.globalError.map((e: GlobalError) => {
        return e.args.map((arg) => {
          apiErrorMessages.value.push(arg);
        });
      });
    }
  } finally {
    isLoading.value = false;
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e23', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e23' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(emailAddress)), 1)
      ])
    ]),
    _createVNode(ErrorMessage, { errors: apiErrorMessages.value }, null, 8, ["errors"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save,
        disabled: submitDisable.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ]))
}
}

})